import { ObjectSchema, ValidationError } from 'yup'

export const createValidation = (schema: ObjectSchema) =>
  async function validate<T>(values: T) {
    try {
      await schema.validate(values)
      return undefined
    } catch (e) {
      const err = e as ValidationError
      return {
        [err.path]: err.message,
      }
    }
  }
